exports = module.exports = require("./../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".spin-octicon{animation:spin-octicon 2s infinite linear}@keyframes spin-octicon{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/react-octicon/css/Octicon.css
 ** module id = 243
 ** module chunks = 0
 **/